'use client';

import React from 'react';

export default function DateSeparator({ label }: { label: string }) {
  return (
    <div className="flex items-center justify-center my-4" role="separator" aria-label={`Messages from ${label}`}>
      <span
        className="text-[12px] font-medium px-4 py-1.5 rounded-full"
        style={{
          background: 'rgba(0,0,0,0.4)',
          color: '#D7E0EA',
          backdropFilter: 'blur(4px)',
          border: '1px solid rgba(255,255,255,0.06)',
        }}
      >
        {label}
      </span>
    </div>
  );
}